module.exports = __webpack_public_path__ + "img/Profile.5f049db9.svg";